import { html, render } from "lit-html";
import { when } from "lit-html/directives/when.js";
import {
	isAtLeast,
	SIZE_TABLET,
	unwatch as unwatchScreenSize,
	watch as watchScreenSize,
} from "@escapio/portal/dom/screen";
import { linkTargetForProfile } from "@escapio/portal/components/hotel-list/get-offer-url";
import {
	dealTemplate,
	formatDealDateRange,
} from "@escapio/portal/components/deals/get-description-template";
import { track } from "@escapio/portal/tracker/EventTracker";
import { addEventTrackerData } from "@escapio/portal/tracker/EventQueue";
import { translate } from "@escapio/shared/l10n/translate";
import { buildClickProfileLabel } from "@escapio/portal/components/deals/track";
import "../hotel-list/hotel-element/MobileDescription";
import "../hotel-list/hotel-element/MobileStage";
import "../hotel-list/hotel-element/DesktopStage";
import "../hotel-list/hotel-element/DesktopHeader";
import { NORMAL } from "../HotelHighlightStates";
import "@escapio/portal/components/tracker/ImpressionInteractionTracker";

export const EVENT_ACTION_PREFIX = "Deal mit Hotel";

customElements.define(
	"esc-hotel-deal",
	class extends HTMLElement {
		connectedCallback() {
			this.render();
			watchScreenSize(this, this.render.bind(this));
		}

		disconnectedCallback() {
			unwatchScreenSize(this);
		}

		render() {
			const template = html`<esc-impression-interaction-tracker
				content-name="${this.eventCategory} - ${EVENT_ACTION_PREFIX}"
				content-piece="${this.deal.id} | ${this.deal.hotel
					.id} - ${formatDealDateRange(this.deal)}"
				content-target="${this.deal.hotel.path}"
				interaction-targets-selector=".deal__cta--interaction-tracking"
			>
				${when(
					isAtLeast(SIZE_TABLET),
					this.renderTablet.bind(this),
					this.renderMobile.bind(this),
				)}
			</esc-impression-interaction-tracker>`;
			render(template, this, { host: this });
		}

		renderMobile() {
			return html`<esc-hotel-list-hotel-stage-mobile
					.hotel="${this.deal.hotel}"#
					track-disabled
					.profileLinkHandler="${this.onStagePictureClick.bind(this)}"
					.addToFavoritesHandler="${this.onAddToFavorites.bind(this)}"
					hide-escapio-deals-badges
			></esc-hotel-list-hotel-stage-mobile>
				<a href=${this.deal.hotel.path} target=${linkTargetForProfile}
					><esc-hotel-list-hotel-description-mobile
						.hotel=${this.deal.hotel}
						@click="${() => this.track("Hotelname")}"
				></esc-hotel-list-hotel-description-mobile
				></a>
				${this.dealTemplate}
				</div>`;
		}

		renderTablet() {
			return html`<div class="hotel-list-item-desktop__container">
				<esc-hotel-list-hotel-stage-desktop
					.hotel=${this.deal.hotel}
					.type=${NORMAL}
					.isLoading=${false}
					.profileLinkHandler="${this.onStagePictureClick.bind(this)}"
					.addToFavoritesHandler="${this.onAddToFavorites.bind(this)}"
					hide-escapio-deals-badges
				></esc-hotel-list-hotel-stage-desktop>

				<div class="deal-list-item-desktop__data">
					<a
						class="hotel-list-item-desktop__header"
						href=${this.deal.hotel.path}
						target=${linkTargetForProfile}
						@click="${() => this.track("Hotelname")}"
					>
						<esc-hotel-list-hotel-header-desktop
							.hotel=${this.deal.hotel}
						></esc-hotel-list-hotel-header-desktop>
					</a>
					${this.dealTemplate}
				</div>
			</div>`;
		}

		onStagePictureClick(currentPicture) {
			this.track(`Bild (${currentPicture + 1})`);
		}

		onAddToFavorites() {
			track(
				this.eventCategory,
				`Deal mit Hotel - Merken - ${this.deal.hotel.id} - ${formatDealDateRange(
					this.deal,
				)}`,
				this.eventLabel,
			);
		}

		get dealTemplate() {
			return dealTemplate(translate("deals_list_cta_label_hotel"), this.deal);
		}

		get eventCategory() {
			return this.getAttribute("event-category");
		}

		get eventLabel() {
			return this.getAttribute("event-label");
		}

		track(context) {
			addEventTrackerData(
				this.eventCategory,
				buildClickProfileLabel(EVENT_ACTION_PREFIX, context, this.deal),
				this.eventLabel,
			);
		}
	},
);
